import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { useIntl } from 'umi';
import { SteamingMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/SteamingCloums';
import {
  getImgfromName,
  getMetrics,
} from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Streaming/_util';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { valueFormat, growthFormat } from '@/pages/intelligence/utils/commonUtils';
import UserDefaultIcon from '@/pages/intelligence/assets/svg/tipicon/kol-default.svg';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { buildMetricCompareData } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/metricCompare';

const ChannelsCard = (props: any) => {
  const {
    // loading,
    tableData = [],
    totalNum = 0,
    totalData,
    tableHeaderOptions = [],
    onTableSortChage,
    onTablePagingChange,
    pageSortAttr,
    tableLoading,
    entityType,
    gameName,
    gameCover,
    startDate,
    endDate,
  } = props;
  const [loading, setLoading] = useState(tableLoading);
  const { formatMessage } = useIntl(); // 中英切换方法
  const [pageSortTable, setPageSortTable] = useState<any[]>([]);
  // const [pageSortAttr, setPageSortAttr] = useState({
  //   currentSortValue: 'desc',
  //   currentSortMetric: chartSegment,
  //   currentRatioType: 0,
  // });
  useEffect(() => {
    setLoading(tableLoading);
  }, [tableLoading]);

  const {
    tablePageIndex,
    tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  // const [pageSize, setPageSize] = useState(tablePageSize || 5);
  const [pageSize, setPageSize] = useState(tablePageSize || 10);

  useEffect(() => {
    const newTableData = tableData?.slice(0);
    newTableData?.unshift(totalData ? totalData || {} : {});
    setPageSortTable(newTableData);
  }, [JSON.stringify(tableData)]);

  // useEffect(() => {
  //   onSortChage({
  //     sortMetric: chartSegment,
  //     sortVal: 'desc',
  //     ratioType: 0,
  //   });
  // }, [chartSegment]);

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
    setPageSortTable([]);
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || 5);
    onTablePagingChange(e);
    setPageSortTable([]);
  };

  const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
    const metric = getMetrics(cvm?.channel_metric_info, metricKey, 'metric');
    // let metric = getPlatform(cvm?.platform, key);
    const value = valueFormat(metric?.value);
    const growthDataObj = growthFormat({
      value: metric?.dod_int,
      valueType: 'percentValue',
      hasPoint: 'lessThanOne',
      fixedNum: 2,
      maxNumber: 99999,
      zeroValue: '0% -',
    });
    const dataCompareData = buildMetricCompareData({
      metric,
      granularity: 'daily',
      startDate,
      endDate,
      title: gameName || '',
      icon: gameCover || '',
      entityType: entityType || 'mobile',
      prevValueConfig: {
        ratioValueKeys: ['dod_int', 'growth_ratio'],
      },
      valueFormatter: (rawValue) => {
        const numValue = Number(rawValue);

        if (!Number.isFinite(numValue)) {
          return '-';
        }

        return valueFormat(numValue);
      },
    });

    return {
      value,
      growthDataObj,
      dataCompareData,
    };
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    // DAU Revenue Download 每个数据源赋值一遍
    tableHeaderOptions?.forEach((t) => {
      metricCloums.push(
        SteamingMetricColumn({
          // dataSource: t?.dataSource,
          width: t?.width,
          title: t?.text,
          textContent: t?.textContent ? formatMessage({ id: t?.textContent }) : undefined,
          key: `${t?.value}`,
          sortMetric: t?.value,
          currentSortValue,
          currentSortKey: `${currentSortMetric}_${currentRatioType}`,
          onSortChage,
          getMetricValueOfCvm,
          entityType,
          metricKey: t?.value,
        }),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <TopchartTable
        //   verticalTop
        // bordered="all"
        loading={loading}
        records={pageSortTable}
        tableTotal={totalNum}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        // pageSizeOptions={[5, 10, 15]}
        className="dbi-mobileGames-details-table"
        columns={[
          {
            key: 'channel',
            header: (
              <div className="stats-table-title">
                <span className="stats-table-title-text">
                  {formatMessage({ id: `dbi_channel` })}
                </span>
              </div>
            ),
            width: 'auto',
            align: 'left',
            render: (cvm: any) => {
              return (
                <ARightClickToJump href={cvm?.url} onlyRightMouseClick={false}>
                  <div className="stats-table-channellabel">
                    {cvm.platform ? (
                      <img
                        src={getImgfromName(cvm?.platform)}
                        alt=""
                        className="stats-table-channellabel-icon"
                      />
                    ) : (
                      ''
                    )}
                    {cvm?.usrname !== 'Total' ? (
                      <img
                        src={cvm?.cover || UserDefaultIcon}
                        onError={(e: any) => {
                          e.target.src = UserDefaultIcon;
                        }}
                        alt=""
                        className="stats-table-channellabel-img"
                      />
                    ) : (
                      ''
                    )}
                    <span className="stats-table-channellabel-text">{cvm?.usrname}</span>
                  </div>
                </ARightClickToJump>
              );
            },
          },
          ...getMetricCloums(),
        ]}
      />
    </>
  );
};

export default ChannelsCard;
